module.exports = __webpack_public_path__ + "assets/8bc8931c745a66de1e35c022a48e86cf.mp3";